import React from 'react';
import { WETLAND_RATINGS } from '../types.js';
import './WetlandRatingSelect.css';

function WetlandRatingSelect({ value, onChange, label, id }) {
  const handleChange = (e) => {
    const selected = e.target.value;
    onChange(selected === '' ? null : selected);
  };

  return (
    <div className="wetland-rating-select">
      <label htmlFor={id} className="wetland-rating-select__label">
        {label}
      </label>
      <select
        id={id}
        className="wetland-rating-select__input"
        value={value || ''}
        onChange={handleChange}
      >
        <option value="">-- Select --</option>
        {WETLAND_RATINGS.map((rating) => (
          <option key={rating} value={rating}>
            {rating}
          </option>
        ))}
      </select>
    </div>
  );
}

export default WetlandRatingSelect;
